/**
 * Shell Application - SSE Enabled Content Component
 * Project: Quantiix Shell (quantiix-shell)
 * Module: src/components/SSEEnabledContent.jsx
 *
 * Wrapper component that provides SSE (Server-Sent Events) context
 * to child components with authentication token
 */

import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { SSEProvider } from '../contexts/SSEContext';

export const SSEEnabledContent = ({ children }) => {
    const { token } = useAuth();

    return (
        <SSEProvider authToken={token}>
            {children}
        </SSEProvider>
    );
};